module.exports = __webpack_public_path__ + "static/mother-eedfa4c23cbffacd3cf6d1e50c3682ef.png";